var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.iconPath,"alt":_vm.name}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),(_vm.desc)?_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }